import { SVGProps } from 'react';
import { Icon } from './type';

export const ArrowUpIcon: Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M15 20H9.00003V12H4.16003L12 4.16L19.84 12H15V20Z" fill="black" />
  </svg>
);
